import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import { symphonyCostInvoiceExport, symphonySaleInvoiceExport } from "@/requests/bookkeepping";

import { FILTER_NAMES } from "@/static/filterNames";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";

export interface BookkeepingSymphonyStateInterface {
  recordStampId: number | null;
  costInvoiceExportFilters: Array<CriterionItemRequest> | null;
  saleInvoiceExportFilters: Array<CriterionItemRequest> | null;
  isLoading: boolean;
}

export const BookkeepingSymphonyState: BookkeepingSymphonyStateInterface = {
  recordStampId: null,
  saleInvoiceExportFilters: null,
  costInvoiceExportFilters: null,
  isLoading: true,
};

const BookkeepingSymphonyModule = defineModule({
  state: BookkeepingSymphonyState as BookkeepingSymphonyStateInterface,
  namespaced: true as const,
  modules: {},
  getters: {},
  mutations: {
    setSaleInvoiceExportFilters(state, param: Array<CriterionItemRequest> | null) {
      state.saleInvoiceExportFilters = param;
    },
    setCostInvoiceExportFilters(state, param: Array<CriterionItemRequest> | null) {
      state.costInvoiceExportFilters = param;
    },
    setIsLoading(state, param: boolean) {
      state.isLoading = param;
    },
    setRecordStampDialog(state, param: number | null) {
      state.recordStampId = param;
    },
  },
  actions: {
    async exportSaleInvoice(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsLoading(true);
      await symphonySaleInvoiceExport(
        state.saleInvoiceExportFilters,
        FILTER_NAMES.SymfoniaExportSaleInvoiceStandardFilter
      );
      commit.setIsLoading(false);
    },
    async exportCostInvoice(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsLoading(true);
      await symphonyCostInvoiceExport(
        state.costInvoiceExportFilters,
        FILTER_NAMES.SymfoniaExportCostInvoiceStandardFilter
      );
      commit.setIsLoading(false);
    },
  },
});

export default BookkeepingSymphonyModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, BookkeepingSymphonyModule);
